import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from "ramda"
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGlobalDBARegistriesListItems, selectGlobalDBARegistriesQueryItems } from '../../../../redux/global-dba-registries/selector';
import { selectAccountsListItems } from '../../../../redux/accounts/selector';
import { globalDBARegistries } from '../../../../redux/global-dba-registries/action';
import { accounts } from '../../../../redux/accounts/action';
import PageLoader from '../../../../components/PageLoader';
import DBAComponent from '../component/global-dba-registries.component';
import { gateways } from '../../../../redux/gateways/action';
import { selectGatewaysListItems } from '../../../../redux/gateways/selector';
import { dbnp } from '../../../../redux/dbnp/action';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import { selectDbnpListItems } from '../../../../redux/dbnp/selector';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import storePersist from '../../../../redux/storePersist';


const GlobalDBARegistry= () => {  

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalDBARegistriesListItems)
  const gatewayItems = useSelector(selectGatewaysListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
   const accountItems = useSelector(selectAccountsListItems)
    const dpnpNameLists = useSelector(selectDbnpListItems)
       const globalDbnTaxonomyDomainNameLists = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
       const librariesItems = storePersist?.get("library")?.current;
       const countries =  storePersist.get('countries').current?.items;
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDba,
    setSelectedDba
  ] = useState<any>([])
 
  const fetchdbasById= ()=>{
    dispatch(globalDBARegistries.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dba-registries/fetch-detail`,entity:'dbass',jsonData:{
          
    "Context":{},
      "Records": [
      {
              "Id": parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }
 const parentDomain = globalDbnTaxonomyDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === false
    )
    const subDomains = globalDbnTaxonomyDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === true
    )
  const fetchGatewaysList = () => {
    if (!selectedDba?.DBAId) return; // Avoid API call if DBAId is missing
    dispatch(gateways.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/fetch`,
      entity: 'gateways',
      jsonData: {
        Context: {},
        Records: [
          {
            DBAId: selectedDba?.DBAId
          },
        ],
        Pagination: {
          PageNumber: 1,
          PageSize: 100,
          SortField: "DisplayOrder",
          SortOrder: "desc",
        },
      }
    }))
      
  };
// Fetch gateways when selectedDba updates
useEffect(() => {
  if (selectedDba?.DBAId) {
    fetchGatewaysList();
  }
}, [selectedDba]);
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDba({ ...selectedDba, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedDba({ ...selectedDba, [fields[0]]: value });
  }
  useEffect(
    () => {
       dispatch(dbnp.list({ 
                      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`, 
                      entity: 'dbnp', 
                      jsonData: {} 
                  })).then(() => {
                      dispatch(globalDbnTaxonomyDomains.list({ 
                          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, 
                          entity: 'opennetworkDomains', 
                          jsonData: {"Context": {},
              "Records": [
                  {
                      "IsSubDomain": null //to get all records 
                  }
              ],
              "Pagination": {
                "PageNumber": 1,
                "PageSize": 100,
                "SortField": "GlobalDBNDomainId",
                "SortOrder": "desc",
              }} 
                      }))
                  }).then(() => {
        dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
            entity: 'accounts',
            jsonData:
            {}
         }))}).then(()=>{
      if (parmas?.id > 0) {
        fetchdbasById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDba(queryItems?.result?.items[0])
      }
    },
    [isQuery]
  )
 
const back=()=>{
  navigate('/dbn/global-dba-registry')
} 
const [gatewayIds, setGatewayIds] = useState<number[]>([]);

useEffect(() => {
  if (gatewayItems?.result?.items?.length > 0) {
    const ids = gatewayItems.result.items.map((item: any) => item.GatewayId);
    setGatewayIds(ids);
  }
}, [gatewayItems]);
    return (
    <>
       {isLoading ? <PageLoader /> : 
          <DBAComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDba={selectedDba}
           back={back}
           handleFormChange={handleFormChange}
           accounts={accountItems?.result?.items}
           gatewayIds={gatewayIds}
                dbnpname={dpnpNameLists?.result?.items}
                    opsnumber={librariesItems?.Ops_no}
                    domains={parentDomain}
                    subDomains={subDomains}
                    countries={countries}
                      id={parmas?.id}
          /> 
    } 
          </>
    )
    
    }
   
    export default GlobalDBARegistry;
